import React from 'react';
import Divider from './divider';

const Controls = ({ children }) => (
  <div className="ws-ui-editor-header__controls">
    <Divider />
    {children}
    <Divider />
  </div>
);

export default Controls;
